import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import type {
  OgcOnboardingMode,
  ResourceServerId,
} from '../dataset-home/dataset-home.models';
import {
  getResourceServerDisplay,
  ogcOnboardingModeLabel,
} from '../resource-server.util';

@Component({
  selector: 'lib-resource-server-summary',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './resource-server-summary.component.html',
  styleUrl: './resource-server-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourceServerSummaryComponent {
  readonly resourceServer = input<ResourceServerId>('ngsi-ld');
  readonly ogcOnboardingMode = input<OgcOnboardingMode | null | undefined>(null);

  readonly display = computed(() => getResourceServerDisplay(this.resourceServer()));

  readonly ogcModeLabel = computed(() =>
    this.resourceServer() === 'ogc' ? ogcOnboardingModeLabel(this.ogcOnboardingMode()) : '',
  );
}
